import React, { useState, useEffect } from "react";
import { Dropdown, Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getName } from "../../CommonMethhods/CommonMethods";
import lightMode from "../../asset/images/light_mode.svg";
import { Constants } from "../../CommonMethhods/Constants";
import DownLightArrow from "../../asset/images/icons/down-arrow-light.svg";
import DownDmArrow from "../../asset/images/icons/neon_arrow_dm.svg";
import { SSOSERVICES } from "../../Configuration/Telecaller_URl";
import ChangePasswordForm from "../login/ChangePasswordForm";
import { axiosPlainInstance } from "../../CommonMethhods/axiosInstance";

function Profiledropdown(props) {
  const navigate = useNavigate();
  // State For change pss modal
  const [logOutPopup, setLogOutPopup] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [passChangeModal, setPassChangeModal] = useState(false);
  const identifyFlag = sessionStorage.getItem("identifyFlag");
  const partnerUserName = localStorage.getItem("partnerUserName");

  let UserName = localStorage.getItem("userName");

  // For change pss modal end

  useEffect(() => {
    let mode = localStorage.getItem("darkmode");
    let element = document.body;
    if (mode == "true") {
      element.classList.add("darkmode");
    } else {
      if (element.className.includes("darkmode")) {
        element.classList.remove("darkmode");
      }
    }
  }, []);

  function forToggle() {
    if (localStorage.getItem("darkmode") === "true") {
      document.getElementById("themeMode").checked = true;
    } else {
      document.getElementById("themeMode").checked = false;
    }
  }

  let basicDetails = props.basicDetails;

  const RmName = localStorage.getItem("RmName");

  // Logout  RM Api

  function darkTheme() {
    const toogleId = document.getElementById("themeMode");
    let element = document.body;

    if (toogleId.checked == true) {
      element.classList.add("darkmode");
      localStorage.setItem("darkmode", true);
    } else {
      if (element.className.includes("darkmode")) {
        element.classList.remove("darkmode");
        localStorage.setItem("darkmode", false);
      }
    }
  }

  const ssoLogout = async () => {
    try {
      const response = await axiosPlainInstance.post(
        SSOSERVICES.SSO_LOGOUT,
        {
          id_token_hint: localStorage.getItem("id_token"),
        },
      );
      const data = await response.data;
      if (data.data === "successfully logout") {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");

        // localStorage.removeItem("id_token");
        // localStorage.removeItem("userId");
        // localStorage.removeItem("ssoToken");
        // localStorage.removeItem("userName");
        // localStorage.removeItem("project");
        // localStorage.removeItem("userType");
        // localStorage.removeItem("mob");
        // localStorage.removeItem("ClientName");
      } else {
      }
    } catch (err) {
      console.log("Error", err.message);
    }
  };

  function confirmLogout() {
    ssoLogout();

    setLogOutPopup(false);
  }
  function LogoutButton() {
    setLogOutPopup(true);
  }
  function closeNoButton() {
    setLogOutPopup(false);
  }
  return (
    <>
      <Dropdown className={`profile-detail ${props.showUserId ? "profile-detail--with-id" : ""}`}>
        <Dropdown.Toggle
          variant="success"
          id="dropdown-basic"
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            border: "none",
            boxShadow: "none",
            padding: "0",
          }}
        >
          {/* condition will be write here */}
          {/* {(UserName != null || undefined) && props.portal == "TELECALLER" ? (
            <>
              <div className="profile-img">
                <p>{UserName ? getName(UserName).toUpperCase() : ""}</p>
              </div>
              <div className="profile-name">
                <h4>{UserName ? UserName.toUpperCase() : ""}</h4>
              </div>
            </>
          ) : (
            <>
              <div className="profile-img">
                <p>{RmName ? getName(RmName).toUpperCase() : ""}</p>
              </div>
              <div className="profile-name">
                <h4>{RmName ? RmName.toUpperCase() : ""}</h4>
              </div>
            </>
          )} */}
          <>
            <div className="profile-img">
              <p>
                {identifyFlag == "true" && partnerUserName
                  ? getName(partnerUserName).toUpperCase()
                  : UserName
                  ? getName(UserName).toUpperCase()
                  : ""}
              </p>
            </div>
            <div className="profile-name">
              <h4>
                {identifyFlag == "true" && partnerUserName
                  ? partnerUserName.toUpperCase()
                  : UserName
                  ? UserName.toUpperCase()
                  : ""}
              </h4>
              {props.showUserId && (
                <span className="profile-userid">
                  User ID: {localStorage.getItem("userId") || "-"}
                </span>
              )}
            </div>
          </>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="dropdown-item-wrapper">
            <img src={DownLightArrow} className="light-down-arrow"></img>
            <img src={DownDmArrow} className="dm-down-arrow"></img>
            <Dropdown.Item>
              <button
                className="darkmodebtn"
                onClick={() => setModalShow(true)}
              >
                {/* <img id="newimg1" src={Setting} alt="" /> */}
                <span className="icon-setting"></span>
                {Constants.Settings}
              </button>
            </Dropdown.Item>
            <Dropdown.Item>
              {/* {UserName != null || UserName != undefined ? ( */}
              <>
                <button
                  className="signout-button"
                  // to="/"
                  onClick={LogoutButton}
                >
                  <span className="icon-logout-icon signoutimg"></span>
                  {Constants.Sign_out}
                </button>
              </>
              {/* ) : ( */}
              {/* <>
                  {" "}
                  <button
                    className="signout-button"
                    // to="/"
                    onClick={logout}
                  >
                    <span className="icon-logout-icon signoutimg"></span>
                    {Constants.Sign_out}
                  </button>
                </> */}
              {/* )} */}
              {/* <button
                className="signout-button"
                // to="/"
                onClick={LogoutButton}
              >
                <span className="icon-logout-icon signoutimg"></span>
                {Constants.Sign_out}
              </button> */}
              {/* <button
                className="signout-button"
                // to="/"
                onClick={logout}
              >
                <span className="icon-logout-icon signoutimg"></span>
                {Constants.Sign_out}
              </button> */}
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>

      {/* Modal start */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model"
        backdrop="static"
        keyboard={false}
        onLoad={() => forToggle()}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">{Constants.Settings}</h2>

            <p className="model-subtitle">
              {Constants.Change_Account_settings}
            </p>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setModalShow(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="setting">
            <div className="setting-left-side">
              <ul className="">
                {props.portal == "TELECALLER" && (
                  <>
                    <li className="darkmode-content setting-div">
                      <div className="setting-left">
                        <img src={lightMode} className="light-mode-icon" />
                        <span className="icon-dark_mode setting-left-icon"></span>
                        <div className="darkmode-cont">
                          <span className="setting-label">
                            {Constants.Dark_Theme}
                          </span>
                          <span className="setting-samll-desc">
                            {Constants.Denotes_combination_light}
                          </span>
                        </div>
                      </div>
                      <div className="setting-right">
                        <div className="toggle-dark">
                          <label className="switch" onClick={darkTheme}>
                            <input type="checkbox" id="themeMode" />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>

                      {/* <button className="darkmodebtn-toggle" onClick={darkTheme}>
                    <div className='ball'></div>
                  </button> */}

                      {/* <div className="profile-dark">
            <input type="checkbox" className="checkbox" id="checkbox" onClick={toggleMode} />
            <label for="checkbox" className="label">
              <div className='ball'></div>
            </label>
          </div> */}
                    </li>
                  </>
                )}

                {(UserName != null || undefined) &&
                  (props.portal == "RM" || props.portal == "IBA") && (
                    <>
                      <li
                        // className="change-pwd-cont-wrapper"
                        onClick={() => {
                          setModalShow(false);
                          setPassChangeModal(true);
                        }}
                      >
                        <span className="icon-change_password setting-left-icon"></span>
                        <div className="change-pwd-cont">
                          <span className="setting-label">
                            {Constants.Change_Password}
                          </span>
                          <span className="setting-samll-desc">
                            {Constants.Set_new_Password}
                          </span>
                        </div>
                      </li>
                      <li className="darkmode-content setting-div">
                        <div className="setting-left">
                          <img src={lightMode} className="light-mode-icon" />
                          <span className="icon-dark_mode setting-left-icon"></span>
                          <div className="darkmode-cont">
                            <span className="setting-label">
                              {Constants.Dark_Theme}
                            </span>
                            <span className="setting-samll-desc">
                              {Constants.Denotes_combination_light}
                            </span>
                          </div>
                        </div>
                        <div className="setting-right">
                          <div className="toggle-dark">
                            <label className="switch" onClick={darkTheme}>
                              <input type="checkbox" id="themeMode" />
                              <span className="slider round"></span>
                            </label>
                          </div>
                        </div>

                        {/* <button className="darkmodebtn-toggle" onClick={darkTheme}>
                    <div className='ball'></div>
                  </button> */}

                        {/* <div className="profile-dark">
            <input type="checkbox" className="checkbox" id="checkbox" onClick={toggleMode} />
            <label for="checkbox" className="label">
              <div className='ball'></div>
            </label>
          </div> */}
                      </li>
                    </>
                  )}

                {/* <li className="language-cont-wrapper">
              <span className="icon-language setting-left-icon"></span>
              <div className="language-cont">
                <span className="setting-label">Language</span>
                <span className="setting-samll-desc">Change your</span>
              </div>
            </li> */}
              </ul>
              {/* <div className="btn-wrapper">
              <button className="btn cancel-btn">Cancel</button>
              <button className="btn save-btn">Save</button>
            </div> */}
            </div>
            {/* <div className="setting-right-side">
            <div>

            </div>
            <div className="btn-wrapper">
              <button className="btn cancel-btn">Cancel</button>
              <button className="btn save-btn">Save</button>
            </div>
          </div> */}
          </div>
        </Modal.Body>
      </Modal>

      {/* change password modal */}
      <Modal
        show={passChangeModal}
        onHide={() => {
          setPassChangeModal(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <h2 className="model-title">{Constants.Change_Password}</h2>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setPassChangeModal(false);
            }}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <ChangePasswordForm titleChangePass={false} />
        </Modal.Body>
      </Modal>
      <Modal
        show={logOutPopup}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rm-model"
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">LOG OUT</Modal.Title>
          <button
            type="button"
            onClick={closeNoButton}
            className="btn-close filter-closeBtn"
            aria-label="Close"
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <h4 className="section-title">
            Are you sure,you want to LogOut your application?
          </h4>
          <div className="btn-yes-no">
            <Button
              className="yes-btn confirmation-btn"
              onClick={confirmLogout}
            >
              Yes
            </Button>
            <Button
              className="no-btn confirmation-btn"
              closebutton
              onClick={closeNoButton}
            >
              No
            </Button>
          </div>
        </Modal.Body>
        {/* <Modal.Footer> */}

        {/* </Modal.Footer> */}
      </Modal>
    </>
  );
}

export default Profiledropdown;

